import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from 'app/components'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { LogsUsuarioColumns } from './columns/_columns'
import { UsuarioList } from '../../../usuarios/usuarios-list/core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

export const LogsUsuarioTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => LogsUsuarioColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={`Nenhum usuário encontrado para “${filters.nome.trim()}”`}
      description='Revise o nome digitado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState title='Nenhum usuário para exibir' />
  )

  return (
    <CustomTable<UsuarioList>
      id='kt_table_usuarios'
      ariaLabel='Usuários com logs'
      itemLabel={{ singular: 'usuário', plural: 'usuários' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
